import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TPpwrEmCountryExclusion } from 'redux/reducers/ppwr/types';

export const EDIT_ACTION = 'Edit';

export const tableStructure: TTableStructure<
	keyof TPpwrEmCountryExclusion,
	TPpwrEmCountryExclusion
>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country',
		selector: 'country',
		value: (item) => item.country?.iso2Code ?? String(item.countryId),
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE_EU,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Reason',
		selector: 'reason',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.MULTILINE_TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Reports Done By',
		selector: 'reportsDoneBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'LUCID',
		selector: 'lucid',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Valid Till',
		selector: 'validTill',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Dashboard Updated At',
		selector: 'dashboardUpdatedAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Dashboard Updated By',
		selector: 'dashboardUpdatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: EDIT_ACTION, icon: EIconButtons.EDIT }],
	},
];
